import { render } from "./DocumentClassTableColumns.vue?vue&type=template&id=822d7ee4&scoped=true&ts=true"
import script from "./DocumentClassTableColumns.vue?vue&type=script&lang=ts"
export * from "./DocumentClassTableColumns.vue?vue&type=script&lang=ts"

import "./DocumentClassTableColumns.vue?vue&type=style&index=0&id=822d7ee4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822d7ee4"]])

export default __exports__